export const INVOICES_BASE_BATH = 'factures';
export const FORMALITIES_INVOICES_LIST = '/formalites/factures';
